import React, { useState } from 'react';
import { useAppContext } from '../../contexts/AppContext';
import AlertModal from '../AlertModal';
import styles from './index.module.scss';

const FeedbackModal = ({
  visible,
  onClose,
  onSubmit,
  question,
  processType,
  questionId
}) => {
  const { showAlert, alertModal, closeAlert } = useAppContext();
  const [feedbackContent, setFeedbackContent] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!feedbackContent.trim()) {
      await showAlert('warning', '输入错误', '请输入反馈内容');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit({
        question,
        content: feedbackContent.trim(),
        processType,
        questionId
      });

      // 显示成功弹窗
      await showAlert('success', '提交成功', '反馈提交成功！感谢您的反馈。');

      // 重置表单
      setFeedbackContent('');
      onClose();
    } catch (error) {
      console.error('提交反馈失败:', error);
      await showAlert('error', '提交失败', '提交失败，请重试');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setFeedbackContent('');
    onClose();
  };

  if (!visible) return null;

  return (
    <div className={styles.modalOverlay} onClick={handleClose}>
      <div className={styles.modalContainer} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>问题反馈</h3>
          <button className={styles.closeButton} onClick={handleClose}>×</button>
        </div>

        <div className={styles.modalContent}>
          <div className={styles.questionInfo}>
            <h4>当前问题：</h4>
            <p className={styles.questionText}>{question}</p>
          </div>

          <div className={styles.feedbackSection}>
            <label htmlFor="feedbackContent">
              <h4>请描述您的反馈内容：</h4>
            </label>
            <textarea
              id="feedbackContent"
              className={styles.feedbackTextarea}
              value={feedbackContent}
              onChange={(e) => setFeedbackContent(e.target.value)}
              placeholder="请详细描述您对此问题的反馈意见，例如：问题描述不清楚、选项不够准确、缺少某些选项等..."
              rows={6}
              disabled={isSubmitting}
            />
          </div>

          <div className={styles.processInfo}>
            <span className={styles.processTag}>工艺类型: {processType}</span>
            <span className={styles.questionTag}>问题ID: {questionId}</span>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button 
            className={styles.cancelButton} 
            onClick={handleClose}
            disabled={isSubmitting}
          >
            取消
          </button>
          <button 
            className={styles.submitButton} 
            onClick={handleSubmit}
            disabled={isSubmitting || !feedbackContent.trim()}
          >
            {isSubmitting ? '提交中...' : '提交反馈'}
          </button>
        </div>
      </div>

      {/* 弹窗组件 */}
      <AlertModal
        isOpen={alertModal.isOpen}
        type={alertModal.type}
        title={alertModal.title}
        message={alertModal.message}
        confirmText={alertModal.confirmText}
        cancelText={alertModal.cancelText}
        showCancel={alertModal.showCancel}
        onConfirm={alertModal.onConfirm}
        onCancel={alertModal.onCancel}
        onClose={closeAlert}
      />
    </div>
  );
};

export default FeedbackModal;
